export const notifyFlash = (message) => ({
    type: 'NOTIFY_FLASH_MESSAGE',
    payload: { message },
})

export const notify = ({ title = '', body = '', isDismissible = true, callback = null }) => ({
    type: 'NOTIFY_MESSAGE',
    payload: { title, body, isDismissible, callback },
})

export const dismiss = (id) => ({
    type: 'DISMISS_MESSAGE',
    payload: { id },
})

export const dismissAll = () => ({
    type: 'DISMISS_ALL_MESSAGES',
})

export const dismissFlash = (id) => ({
    type: 'DISMISS_FLASH_MESSAGE',
    payload: { id },
})
